import { PaymentMethodSelector as PaymentMethodSelectorShared } from '../../../../components/Containers/ReviewCheckoutDrawer/PaymentMethod/PaymentMethodSelector';
import { useFlow } from '../../../../providers';
import { usePreAuthOfferCtx } from '../../../../providers/PreAuthOfferProvider';

export const PaymentMethodSelector = () => {
  const {
    handlePaymentMethodUpdate,
    isNewPaymentMethod,
    paymentMethods,
    selectedPaymentMethodId,
    setSelectedPaymentMethodId,
  } = usePreAuthOfferCtx();
  const { goToStep } = useFlow();

  return (
    <PaymentMethodSelectorShared
      canSave={selectedPaymentMethodId !== null || isNewPaymentMethod}
      onSave={async (paymentMethodId) => {
        if (!paymentMethodId) return;
        await handlePaymentMethodUpdate(paymentMethodId);
        goToStep('review');
      }}
      paymentMethods={paymentMethods?.listPaymentMethods || []}
      selectedPaymentMethodId={selectedPaymentMethodId || null}
      setSelectedPaymentMethodId={setSelectedPaymentMethodId}
    />
  );
};
